import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ItdrIntegrationKey } from '../../services/identity-security.service';

const INTEGRATION_LABEL: Record<ItdrIntegrationKey, string> = {
  entraId: 'Microsoft Entra ID',
  m365: 'Microsoft 365',
};

@Component({
  selector: 'app-itdr-missing-integration',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './itdr-missing-integration.component.html',
  styleUrl: './itdr-missing-integration.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItdrMissingIntegrationComponent {
  /** Integration keys the customer still needs to configure. */
  public missing = input<ItdrIntegrationKey[]>([]);

  /** Names of missing integrations in display order, for use in copy. */
  public missingLabels = computed(() => this.missing().map((key) => INTEGRATION_LABEL[key]));

  /**
   * The integration to deep-link to from the CTA. We pick the first missing
   * integration; the customer can configure the second one inline on the same page.
   */
  public ctaTarget = computed(() => this.missing()[0] ?? 'entraId');

  public ctaLabel = computed(() => `Configure ${INTEGRATION_LABEL[this.ctaTarget()]}`);

  /** True when the customer is missing more than one integration and we should show extra copy. */
  public hasSecondaryMissing = computed(() => this.missing().length > 1);
}
